import { render, staticRenderFns } from "./Bouton.vue?vue&type=template&id=7e1415c4&"
import script from "./Bouton.vue?vue&type=script&lang=ts&"
export * from "./Bouton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e1415c4')) {
      api.createRecord('7e1415c4', component.options)
    } else {
      api.reload('7e1415c4', component.options)
    }
    module.hot.accept("./Bouton.vue?vue&type=template&id=7e1415c4&", function () {
      api.rerender('7e1415c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/ob1/Bouton.vue"
export default component.exports